// todo move this file to module
export const dashboardVerificationAccess = {
    '0': 'بدون تاییدیه',
    '1': 'تایید شماره همراه',
    '2': 'تایید ایمیل',
    '3': 'تایید ایمیل و شماره همراه',
}

export const orderVerificationAccess = {
    '0': 'بدون تاییدیه',
    '1': 'تایید ایمیل',
    '2': 'تایید شماره همراه',
    '3': 'تایید ایمیل و شماره همراه',
}

export const cartType = {
    '0': 'ساخت سبد بدون ثبت نام',
    '1': 'ساخت سبد بعد از ثبت نام',
}

export const registerType = {
    '0': 'تایید شماره تلفن بعد از ثبت نام',
    '1': 'تایید شماره تلفن هنگام ثبت نام',
}
